"use client";

import { c as _c } from "react/compiler-runtime";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import { ImageScale } from "@/helpers/image.helpers";
import { getDropPreviewImageUrl, type ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useMemo } from "react";
interface SubmissionArtworkCardProps {
  readonly drop: ExtendedDrop;
  readonly isActive?: boolean;
  readonly imageScale?: ImageScale;
  readonly renderMode?: "full" | "preview" | "placeholder";
}
export default function SubmissionArtworkCard(t0) {
  const $ = _c(15);
  const {
    drop,
    isActive: t1,
    imageScale: t2,
    renderMode: t3
  } = t0;
  const isActive = t1 === undefined ? true : t1;
  const imageScale = t2 === undefined ? ImageScale.AUTOx600 : t2;
  const renderMode = t3 === undefined ? "full" : t3;
  const media = drop.parts[0]?.media[0];
  let t4;
  if ($[0] !== drop.metadata) {
    t4 = getDropPreviewImageUrl(drop.metadata);
    $[0] = drop.metadata;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const previewImageUrl = t4;
  if (!media) {
    return null;
  }
  let t5;
  if ($[2] !== media.mime_type) {
    t5 = media.mime_type?.includes("image");
    $[2] = media.mime_type;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const isImage = t5;
  const canRenderPreview = !!previewImageUrl || isImage;
  const shouldRenderPlaceholder = renderMode === "placeholder" || renderMode === "preview" && !canRenderPreview;
  const mediaWrapperClasses = `tw-h-full tw-w-full ${isActive ? "tw-shadow-[0_8px_32px_rgba(255,255,255,0.08)]" : "tw-pointer-events-none"}`;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-mt-2 tw-rounded-lg tw-shadow-[inset_0_0_20px_rgba(0,0,0,0.3)] tw-ring-1 tw-ring-inset tw-ring-white/[0.15]" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = isActive ? _temp : undefined;
  let t8;
  if ($[5] !== imageScale || $[6] !== media.mime_type || $[7] !== media.url || $[8] !== previewImageUrl || $[9] !== shouldRenderPlaceholder) {
    t8 = shouldRenderPlaceholder ? <div className="tw-h-full tw-w-full tw-rounded-lg tw-bg-iron-950" /> : <MediaDisplay media_mime_type={media.mime_type ?? "image/jpeg"} media_url={media.url ?? ""} disableMediaInteraction={true} imageScale={imageScale} previewImageUrl={previewImageUrl} />;
    $[5] = imageScale;
    $[6] = media.mime_type;
    $[7] = media.url;
    $[8] = previewImageUrl;
    $[9] = shouldRenderPlaceholder;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== mediaWrapperClasses || $[12] !== t7 || $[13] !== t8) {
    t9 = <div className="tw-relative tw-h-full tw-w-full tw-overflow-hidden tw-bg-black">{t6}<div className={mediaWrapperClasses} onClick={t7}>{t8}</div></div>;
    $[11] = mediaWrapperClasses;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}
function _temp(event) {
  return event.stopPropagation();
}